import { MetricDetails } from '../../../../api/metrics/types';
import { SQLFilters } from '../../../../api/types';
import {
  GroupBy,
  MetricIdType,
  SegmentBy,
  SingleValueTimeSelection,
} from '../../../../types';
import { LanguageString } from '../../dashboards/types';
import { MetricId } from '../../metrics/types';
import { TitleConfig } from '../../ui-components/data-viz-ui/charts/common/common-chart-types';
import { ExternalChartComponentProps } from '../common/types';

import { SegmentedResponse } from '../common/types';

export type TimePeriodSegmentedVizExternalProps = ExternalChartComponentProps;

export interface TimePeriodSegmentedVizQuery {
  timeSelection: SingleValueTimeSelection;
  metric: MetricIdType;
  filters?: SQLFilters;
  groupBy: GroupBy;
  segmentBy: SegmentBy;
}
export interface TimePeriodSegmentedVizConfig {
  title?: LanguageString;
  query: TimePeriodSegmentedVizQuery;
  chartColors?: string[];
}

// Don't really need it here as this vizContainer only supports segmented responses
export type TimePeriodSegmentedVizDataResponse = Omit<
  SegmentedResponse,
  'isSegmented'
>;

export type TimePeriodSegmentedVizData = {
  dataResponse: TimePeriodSegmentedVizDataResponse;
  titleConfig: TitleConfig;
  metricDetails: Partial<Record<MetricId, MetricDetails>>;
  metricDisplayValues: Partial<Record<MetricId, string>>;
  chartColors?: string[];
};

export enum TimePeriodSegmentedVizViews {
  BAR_CHART = 'bar-chart',
  TABLE_VIEW = 'table-view',
}
